import { default as ContactFormModal } from './ContactFormModal';
import { default as OrganizationFormModal } from './OrganizationFormModal';
import { default as OrganizationRailAndPortLocationsModal } from './RailAndPortLocationsModal';
import { default as WebsiteModal } from './WebsiteModal';
import { default as ChassisPoolsModal } from './ChassisPoolsModal';
import { default as OrganizationConflictsModal } from './OrganizationConflictsModal/OrganizationConflictsModal';

export {
  ContactFormModal,
  OrganizationFormModal,
  OrganizationRailAndPortLocationsModal,
  WebsiteModal,
  ChassisPoolsModal,
  OrganizationConflictsModal
};

export const organizationModals = {
  WEBSITE_MODAL: WebsiteModal,
  ADD_ORGANIZATION_MODAL: OrganizationFormModal,
  ORGANIZATION_LOCATIONS_MODAL: OrganizationRailAndPortLocationsModal,
  ORGANIZATION_CHASSISPOOLS_MODAL: ChassisPoolsModal,
  ORGANIZATIONS_CONFLICTS_MODAL: OrganizationConflictsModal
};
